import { render, staticRenderFns } from "./PreviewRightsModal.vue?vue&type=template&id=51471b56&scoped=true&"
import script from "./PreviewRightsModal.vue?vue&type=script&lang=ts&"
export * from "./PreviewRightsModal.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewRightsModal.vue?vue&type=style&index=0&id=51471b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51471b56",
  null
  
)

export default component.exports